
export const ALL_JOBS = 'All';
export const RECOMMENDED_JOBS = 'Recommended';

export const DEFAULT_SELECTED_TAB = RECOMMENDED_JOBS;

export const SHOWING_SKILLS_COUNT = 4;

export const INITIAL_QUERY_STRING_SELECTED_TAB = `?selectedTab=${encodeURIComponent(DEFAULT_SELECTED_TAB)}`;
